import { useState, ChangeEvent, KeyboardEvent } from "react";

import { DUMMY_TEXTS, TERMINAL_OPTIONS } from "./data";

const App = () => {
  const [prompt, setPrompt] = useState("");
  const [content, setContent] = useState([DUMMY_TEXTS.INITIAL]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPrompt(e.target.value.toLowerCase());
  };

  const handleKeyPress = (e: KeyboardEvent) => {
    if (e.key === "Enter") {
      let newContent = "> " + prompt;
      switch (prompt) {
        case TERMINAL_OPTIONS.CMD:
          newContent += DUMMY_TEXTS.CMD;
          setContent((prevState) => [...prevState, newContent]);
          break;

        case TERMINAL_OPTIONS.CLEAR:
          setContent([DUMMY_TEXTS.INITIAL]);
          break;

        case TERMINAL_OPTIONS.LS:
          newContent += DUMMY_TEXTS.LS;
          setContent((prevState) => [...prevState, newContent]);
          break;

        case TERMINAL_OPTIONS.CAT.ABOUT:
          newContent += DUMMY_TEXTS.ABOUT;
          setContent((prevState) => [...prevState, newContent]);
          break;

        case TERMINAL_OPTIONS.CAT.EDUCATION:
          newContent += DUMMY_TEXTS.EDUCATION;
          setContent((prevState) => [...prevState, newContent]);
          break;

        case TERMINAL_OPTIONS.CAT.EXPERIENCE:
          newContent += DUMMY_TEXTS.EXPERIENCE;
          setContent((prevState) => [...prevState, newContent]);
          break;

        case TERMINAL_OPTIONS.CAT.CONTACT_ME:
          newContent += DUMMY_TEXTS.CONTACT_ME;
          setContent((prevState) => [...prevState, newContent]);
          break;

        default:
          break;
      }
      setPrompt("");
    }
  };

  return (
    <div className="container">
      {content.map((text, index) => (
        <p key={index}>{text}</p>
      ))}

      <p className="prompt-input">
        {"> " + prompt}
        <input
          type="text"
          name="prompt"
          id="prompt"
          value={prompt}
          onChange={handleChange}
          onKeyPress={handleKeyPress}
        />
      </p>
    </div>
  );
};

export default App;
